import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Financial summaries must reflect changes immediately after a mutation
      // invalidates their keys. staleTime:0 + refetchOnMount:"always" guarantees
      // returning to a screen (or an active query being invalidated) refetches now,
      // instead of serving stale totals until a later background refresh.
      staleTime: 0,
      refetchOnMount: "always",
      refetchOnWindowFocus: false,
      // networkMode "always" is REQUIRED on native: our axios adapter reads from local
      // SQLite even offline. With the default "online" mode React Query PAUSES queries when
      // the WebView reports offline and never calls the adapter, which left the Add Work
      // practice selector empty offline until a force-close/relaunch.
      networkMode: "always",
    },
    mutations: { networkMode: "always" },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
